<template>
  <invoice-pool-common />
</template>

<script>
import invoicePoolCommon from '@/views/cargo/v0/Clearing/components/invoicePool/invoicePoolCommon'

export default {
  name: 'InvoicePool',
  components: { invoicePoolCommon }
}
</script>

<style scoped lang="scss">
</style>
